// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ccd19dcb","239":"ca540d9f","455":"1fb2a0a3"}[chunkId] + ".chunk.js";
};